import { useEffect, useState } from 'react'

/**
 * Valoarea, întârziată — ca o căutare care se tastează să nu ceară o interogare pe literă.
 *
 * Câmpul rămâne instantaneu pentru om; doar ce ajunge în `queryKey` așteaptă. Fără asta,
 * „Roxana" trimite șase cereri la server, iar ultimele răspunsuri pot sosi în altă ordine
 * decât au plecat.
 */
export function useDebounced<T>(valoare: T, ms = 300): T {
  const [intarziata, setIntarziata] = useState(valoare)

  useEffect(() => {
    const t = setTimeout(() => setIntarziata(valoare), ms)
    return () => clearTimeout(t)
  }, [valoare, ms])

  return intarziata
}
